import {Box} from '@mantine/core';
import {useDisclosure} from '@mantine/hooks';
import type React from 'react';
import {useState} from 'react';
import {NoLoginAlertModal} from '../../../../shared/components/NoLoginAlertModal';
import {formatNumberAsKilo} from '../../../../shared/services/formatNumberAsKilo';
import {suppressFollowCompletionPromptIfChecked} from '../../usecase/followCompletionPromptSuppression';
import {useHandleFollowCompany} from '../../usecase/useHandleFollowCompany';
import {CompanyFollowCompletionModalContainer} from './CompanyFollowCompletionModalContainer';

type Props = {
  companyId: number;
  companyName: string;
  isFollowed: boolean;
  followCount: number;
  dataGtmContent: string;
};

export const FollowCompanyButton: React.FC<Props> = ({
  followCount,
  isFollowed,
  companyId,
  companyName,
  dataGtmContent,
}) => {
  const [checked, setChecked] = useState(false);
  const [followCompletionModalOpened, setFollowCompletionModalOpened] =
    useState(false);

  const closePopup = () => {
    suppressFollowCompletionPromptIfChecked(checked);
    setFollowCompletionModalOpened(false);
  };

  const [isLoginOpened, {open, close}] = useDisclosure(false);
  const {
    handleFollowCompany,
    followCountUpdated,
    isFollowed: isFollowUpdated,
  } = useHandleFollowCompany({
    companyId,
    followCount,
    followed: isFollowed,
    open,
    setFollowCompletionModalOpened,
  });
  return (
    <>
      <Box
        className={`flex cursor-pointer px-8 items-center justify-center pc:hover:opacity-80 border-2 border-primary rounded-16 h-36 ${
          isFollowUpdated ? 'bg-primary text-white' : 'text-primary'
        }`}
        data-gtm-click="company-follow"
        data-gtm-content={dataGtmContent}
        onClick={async (e) => {
          e.stopPropagation();
          try {
            await handleFollowCompany();
          } catch (error) {
            console.error(error);
          }
        }}
      >
        <span className="text-sm font-bold pb-[1px]">
          {isFollowUpdated ? 'フォロー中' : 'フォロー'}
        </span>
        <span className="text-sm mx-4 font-bold">
          {formatNumberAsKilo(followCountUpdated)}
        </span>
      </Box>
      <NoLoginAlertModal opened={isLoginOpened} onClose={close} />
      <CompanyFollowCompletionModalContainer
        companyId={companyId}
        companyName={companyName}
        opened={followCompletionModalOpened}
        onClose={closePopup}
        checked={checked}
        setChecked={setChecked}
      />
    </>
  );
};
